import { render, staticRenderFns } from "./CommonInput.vue?vue&type=template&id=2fb50e64&scoped=true&"
import script from "./CommonInput.vue?vue&type=script&lang=js&"
export * from "./CommonInput.vue?vue&type=script&lang=js&"
import style0 from "./CommonInput.vue?vue&type=style&index=0&id=2fb50e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb50e64",
  null
  
)

export default component.exports